// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1lGHh","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2IBVO","gfeWrapper":"CalendarEvent_gfeWrapper__1oNMs"};